import { connect } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { getPortfolio } from '../../../redux-store/actions/portfolio';
import { getCommercialTrackStatus } from '../../../redux-store/actions/nct';
import { useEffect, useState } from 'react';
import { INPROGRESS, SUCCESS, REJECTED } from '.';
import { formatAsIndianCurrency } from '../../../utils/currency';
import { getDateString } from '../../../utils/constants';
import { maskAccountNo } from '../../../utils/utilityFunctions';
import { List, PurchaseTypes } from './types';
const FP = 'Lumpsum';
const FSIP = 'SIP';
const AP = 'Lumpsum';
const ASIP = 'SIP';
const REDEMPTION = 'Redemption';
const SWITCH = 'Switch';
const STP = 'STP';
const SWP = 'SWP';
const PROSPECT_FOLIO = 'Prospect Folio';
const CSIP = "Cancel SIP";
const PSIP = "Pause SIP";
const OTM_CANCEL = 'OTM Cancel';

const getStatus = (value: string) => {
    const uppercaseValue = (value || '').toUpperCase();
    if (uppercaseValue === 'COMPLETED' || uppercaseValue === 'SUCCESS') {
        return SUCCESS;
    }
    if (uppercaseValue === 'PENDING' || uppercaseValue === 'ACCEPTED') {
        return INPROGRESS;
    }
    if (uppercaseValue === 'ERROR' || uppercaseValue === 'ERRORS') {
        return REJECTED;
    }
    return value;
};

const getTransactionType = (value: string) => {
    const uppercaseValue = (value || '').toUpperCase();
    if (uppercaseValue === 'P') {
        return PROSPECT_FOLIO;
    }
    if (uppercaseValue === 'FP') {
        return FP;
    }
    if (uppercaseValue === 'FSIP') {
        return FSIP;
    }
    if (uppercaseValue === 'AP') {
        return AP;
    }
    if (uppercaseValue === 'ASIP') {
        return ASIP;
    }
    if (uppercaseValue === 'REDEMPTION' || uppercaseValue === 'R') {
        return REDEMPTION;
    }
    if (uppercaseValue === 'SWITCH' || uppercaseValue === 'S') {
        return SWITCH;
    }
    if (uppercaseValue === 'STP' || uppercaseValue === 'ST') {
        return STP;
    }
    if (uppercaseValue === 'SWP' || uppercaseValue === 'SW') {
        return SWP;
    }
    if (uppercaseValue === "PSIP") {
        return PSIP;
    }
    if (uppercaseValue === "CSIP") {
        return CSIP;
    }
    if (uppercaseValue === 'OTMC') {
        return OTM_CANCEL;
    }
    return value;
};

type STPSWPType = {
    startDate: string;
    endDate: string;
    frequency: string;
};

function RenderSourceScheme({
    schemeName = 'NA',
    units = 'NA',
    amount = 'NA',
    nav = 'NA',
    navDate = 'NA',
    stpFlag = false,
    stpSwp,
}: {
    schemeName: string;
    units: string;
    amount: string;
    nav: string;
    navDate: string | Date;
    stpFlag: boolean;
    stpSwp?: STPSWPType;
}) {
    return (
        <div className="ct-track-content">
            <div className="ct-track-content-inner">
                <div className="individual-element">
                    <h5 className="title">Scheme Name</h5>
                    <p>{schemeName}</p>
                </div>
                <div className="individual-element">
                    <h5 className="title">Amount</h5>
                    <p>{formatAsIndianCurrency(Number(amount))}</p>
                </div>

                {stpFlag ? (
                    <>
                        <div className="individual-element">
                            <h5 className="title">Start Date</h5>
                            <p>{getDateString(stpSwp?.startDate || '') || 'NA'}</p>
                        </div>
                        <div className="individual-element">
                            <h5 className="title">End Date</h5>
                            <p>{getDateString(stpSwp?.endDate || '') || 'NA'}</p>
                        </div>
                        <div className="individual-element">
                            <h5 className="title">Frequency</h5>
                            <p>{stpSwp?.frequency || '' || 'NA'}</p>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="individual-element">
                            <h5 className="title">Units</h5>
                            <p>{units || 'NA'}</p>
                        </div>
                        <div className="individual-element">
                            <h5 className="title">Nav</h5>
                            <p>{formatAsIndianCurrency(Number(nav))}</p>
                        </div>
                        <div className="individual-element">
                            <h5 className="title">Nav Date</h5>
                            <p>{getDateString(navDate) || 'NA'}</p>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

const getTitle = (type: PurchaseTypes | null) => {
    switch (type) {
        default:
            return 'TRANSACTION DETAILS';
    }
};

const commonFields: List[] = [
    {
        label: 'Transaction Type',
        dataKey: 'transactionType',
        valueGetter: (data) => getTransactionType(data.transactionType),
    },
    {
        label: 'Date',
        dataKey: 'createdDate',
        type: 'date',
    },
    {
        label: 'Folio',
        dataKey: 'folio',
    },
    {
        label: 'Status',
        dataKey: 'transactionStatus',
    },
];

const paymentTypeField: List = {
    label: 'Payment Type',
    dataKey: 'paymentType',
};

const fpApAndSipFields: List[] = [
    {
        label: 'Amount',
        dataKey: 'amount',
        type: 'currency',
    },
];
const sipFields: List[] = [
    {
        label: 'Start Date',
        dataKey: 'startDate',
        valueGetter: (data) => getDateString(data?.sip?.startDate) || 'NA',
    },
    {
        label: 'End Date',
        dataKey: 'endDate',
        valueGetter: (data) => getDateString(data?.sip?.endDate) || 'NA',
    },
    {
        label: 'Frequency',
        dataKey: 'frequency',
        valueGetter: (data) => data?.sip?.frequency || 'NA',
    },
    {
        label: 'No. of Installments',
        dataKey: 'numInstallments',
        valueGetter: (data) => data?.sip?.noOfInstallments || 'NA',
    },
];

const sipPauseCancelFields: List[] = [
    {
        label: "User Transaction Number",
        dataKey: "userTrxNo",
        valueGetter: (data) => data?.systematicPauseCancel?.userTrxnNo || 'NA',
    },
    // {
    //     label: "AMC name",
    //     dataKey: "amcName"
    // },
    {
        label: 'Amount',
        dataKey: 'amount'
    },
    {
        label: "Start Date",
        dataKey: "startDate",
        valueGetter: (data) => getDateString(data?.systematicPauseCancel?.startDate) || 'NA',
    },
    {
        label: "End Date",
        dataKey: "endDate",
        valueGetter: (data) => getDateString(data?.systematicPauseCancel?.endDate) || 'NA',
    },
    {
        label: "Frequency",
        dataKey: "frequency",
        valueGetter: (data) => data?.systematicPauseCancel?.frequency || 'NA',
    },
    {
        label: "Effective Date",
        dataKey: "effectiveDate",
        valueGetter: (data) => getDateString(data?.systematicPauseCancel?.effectiveDate) || 'NA',
    }
]
const swpFields: List[] = [
    {
        label: 'Start Date',
        dataKey: 'startDate',
        valueGetter: (data) => getDateString(data?.stpSwp?.startDate) || 'NA',
    },
    {
        label: 'End Date',
        dataKey: 'endDate',
        valueGetter: (data) => getDateString(data?.stpSwp?.endDate) || 'NA',
    },
    {
        label: 'Frequency',
        dataKey: 'frequency',
        valueGetter: (data) => data?.stpSwp?.frequency || 'NA',
    },
];
const fpOrApFields: List[] = [
    {
        label: 'Units',
        dataKey: 'units',
    },
    {
        label: 'Nav',
        dataKey: 'nav',
        type: 'currency',
    },
    {
        label: 'Nav Date',
        dataKey: 'navDate',
        type: 'date',
    },
];

const redemptionFields: List[] = [
    {
        label: 'Payout Bank',
        dataKey: 'payoutBank',
        valueGetter: (data) => maskAccountNo(data?.payment?.payoutBank) || '',
    },
    {
        label: 'Payout Account',
        dataKey: 'payoutAccount',
        valueGetter: (data) => maskAccountNo(data?.payment?.payoutAccount) || '',
    },
    {
        label: 'Payout Date',
        dataKey: 'payoutDate',
        type: 'date',
        valueGetter: (data) => maskAccountNo(data?.payment?.payoutDate) || '',
    },
];

const otmFields: List[] = [
    {
        label: 'OMUMRN',
        dataKey: 'omUmrn',
        valueGetter: (data) => data?.otmCancel?.omUmrn || '',
    },
    {
        label: 'Start Date',
        dataKey: 'omStartDate',
        valueGetter: (data) => getDateString(data?.otmCancel?.omStartDate) || '',
    },
    {
        label: 'Expiry Date',
        dataKey: 'omExpiryDate',
        valueGetter: (data) => getDateString(data?.otmCancel?.omExpiryDate) || '',
    },
    {
        label: 'OTM Type',
        dataKey: 'otmType',
        valueGetter: (data) => data?.otmCancel?.otmType || '',
    },
    {
        label: 'Payout Reference No',
        dataKey: 'payoutRefNo',
        valueGetter: (data) => data?.otmCancel?.payoutRefNo || '',
    },
];

const showfields = (type: PurchaseTypes | null, data: any) => {
    if (!data) return null;
    let fields;
    console.log(type)
    switch (type) {
        case PurchaseTypes.SWITCH:
        case PurchaseTypes.STP: {
            fields = [...commonFields];
            break;
        }
        case PurchaseTypes.REDEMPTION: {
            fields = [...commonFields, ...fpOrApFields, ...redemptionFields];
            break;
        }
        case PurchaseTypes.SWP: {
            fields = [...commonFields, ...fpApAndSipFields, ...swpFields];
            break;
        }
        case PurchaseTypes.SIP: {
            fields = [...commonFields, paymentTypeField, ...fpApAndSipFields, ...sipFields];
            break;
        }
        case PurchaseTypes.SUBMIT_SIP_PAUSE_CANCEL: {
            fields = [...commonFields, ...sipPauseCancelFields];
            break;
        }
        case PurchaseTypes.OTM_CANCEL: {
            fields = [...commonFields, ...otmFields];
            break;
        }
        default:
            fields = [...commonFields, paymentTypeField, ...fpApAndSipFields, ...fpOrApFields];
    }
    return fields
        ? fields.map(({ label, dataKey, type, valueGetter }) => {
            const value =
                valueGetter && typeof valueGetter === 'function'
                    ? valueGetter(data)
                    : type === 'currency'
                        ? formatAsIndianCurrency(Number(data[dataKey]), false, true)
                        : type === 'date'
                            ? getDateString(data[dataKey])
                            : data[dataKey];
            const _value = !value && typeof value !== 'boolean' ? 'NA' : value;
            return (
                <div key={dataKey} className="individual-element">
                    <h5 className="title">{label}</h5>
                    <p>{_value}</p>
                </div>
            );
        })
        : null;
};

function TrackStatusTransactionType(props: any) {
    const [trackData, setTrackData] = useState<any>({});
    const [requestType, setType] = useState<PurchaseTypes | null>(null);
    // const [transactionId, setTransaction] = useState('');
    const { transactionId: reqId = '' } = props.match.params || {};
    useEffect(() => {
        async function fetchData() {
            const { pan, pekrn, mobile } = props;
            try {
                let response: any = await props.getCommercialTrackStatus({
                    pan,
                    pekrn,
                    reqId,
                    mobile,
                });
                const { requests = [] } = response.body || {};
                // hanlding default failure cases
                if (!(!!requests && requests.length)) return;
                const { rtaResponse, requestTime, requestType } = requests[0] || {};
                setType(requestType);
                const [_data = {}] = Object.keys(rtaResponse)
                    .map((ele: string) => {
                        const data = rtaResponse[ele];
                        return data.map((item: any) => {
                            return {
                                ...item,
                                amcName: item.amcName,
                                folio: item.folio,
                                createdDate: getDateString(requestTime),
                                pan: props.pan || props.pekrn,
                                status: getStatus(ele),
                                message: item.message || '',
                                schemeName:
                                    item.schemeName ||
                                    item.fromSchemeName ||
                                    item.stpSwp?.fromSchemeName,
                            };
                        });
                    })
                    .flat()
                    .map((item, ind: number) => ({
                        Sno: (ind + 1).toLocaleString('en-US', {
                            minimumIntegerDigits: 2,
                            useGrouping: false,
                        }),
                        ...item,
                    }));
                console.log(_data, 'xxx');
                setTrackData(_data);
                // setTransaction(transactionId);
            } catch (err: any) {
                alert(err.message);
            }
        }
        fetchData();
    }, [reqId]);

    return (
        <div className="curved-bg ct-track">
            <h2 className="heading">
                <a onClick={() => props.history.goBack()}>
                    <img src="/images/left-arrow-black.svg" alt="" />
                </a>
                {trackData.schemeName}
            </h2>
            <p className="order-id">
                TRANSACTION ID : <span>{reqId}</span>
            </p>
            <div className="curved-bg-content curved-bg-table-outer">
                <h4>{getTitle(requestType)}</h4>
                <div className="ct-track-content">
                    <div className="ct-track-content-inner">
                        {showfields(requestType, trackData)}
                    </div>
                </div>
                {requestType === PurchaseTypes.SWITCH && (
                    <div style={{ marginTop: 20 }}>
                        <h4>{'SOURCE SCHEME'}</h4>
                        <RenderSourceScheme {...trackData} />
                    </div>
                )}
                {requestType === PurchaseTypes.SWITCH && (
                    <div style={{ marginTop: 20 }}>
                        <h4>{'TARGET SCHEME'}</h4>
                        <RenderSourceScheme {...trackData.switchIn} />
                    </div>
                )}
                {requestType === PurchaseTypes.STP && (
                    <div style={{ marginTop: 20 }}>
                        <h4>{'SOURCE SCHEME'}</h4>
                        <RenderSourceScheme {...trackData} stpFlag={true} />
                    </div>
                )}
                {requestType === PurchaseTypes.STP && (
                    <div style={{ marginTop: 20 }}>
                        <h4>{'TARGET SCHEME'}</h4>
                        <RenderSourceScheme
                            {...trackData}
                            schemeName={trackData?.stpSwp?.toSchemeName}
                            stpFlag={true}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    { getPortfolio, getCommercialTrackStatus },
)(TrackStatusTransactionType);
